import React from "react";

const PageBuilderContext = React.createContext();

export default PageBuilderContext;
